import React, { useState } from 'react'
import { Button, Card, DatePicker, Drawer, Form, notification, Select } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import { CyprusStatusUpdate, CyprusVisaInOutStatus } from '../actions/chooseStudent'
import { useDispatch } from 'react-redux'
import moment from 'moment'

let { Option } = Select
const statusTypes = [
  'Visa In',
  'Visa Out'
]

const CyprusStatusChangeDrawer = (props) => {
  let { visible, onClose, record, onSubmit } = props
  let [status, setStatus] = useState('')
  let [date, setDate] = useState(moment())
  let dispatch = useDispatch()
  const events = {
    changeStatus: async (record) => {
      let { _id: studentId, applications } = record
      let obj = {
        studentId, applicationId: applications._id, status: status, date: date
      }

      let resp = await dispatch(CyprusVisaInOutStatus(obj))
      if (resp && resp.success) {
        setDate('')
        setStatus('')
        onSubmit()
      }
    }
  }

  return (
    <Drawer
      visible={visible}
      title={`Update Status (Visa In/Visa Out)`}
      width={'30%'}
      closable={true}
      maskClosable={true}
      onClose={onClose}>
      <Card>
        <Form className={'vertical-form'} autoComplete='off'>
          <Form.Item>
            <InputBox title={'Choose Status'}>
              <Select
                placeholder={'Choose Type'}
                value={status}
                onChange={(value) => {
                  setStatus(value)
                }}>
                {statusTypes && statusTypes.length ? statusTypes.map((item) => {
                  return (
                    <Option value={item}>{item}</Option>
                  )
                }) : null}
              </Select>
            </InputBox>
            <InputBox title={'Choose Date'}>
              <DatePicker
                type='date'
                className='form-control'
                value={date}
                onChange={(e) =>
                  setDate(e)
                }
              />
            </InputBox>
          </Form.Item>
          <Form.Item style={{ marginTop: 25 }}>
            <Button type='primary' onClick={() => {
              events.changeStatus(record)
            }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Drawer>
  )
}

export default CyprusStatusChangeDrawer
